import React, { Component } from "react";
import { connect } from "react-redux";

import NoInfoFound from "../../Components/NoInfoFound/NoInfoFound";
import { Badge } from "../../Components/Badge/Badge";
import SearchBox from "../../Components/SearchBox/SearchBox";
import { Spinner } from "../../Components/Spinner/Spinner";

import { callAPI } from "../../assets/Js/backendCommunication";
import projectSettings from "../../assets/Js/projectSettings";
import { getPlainToken } from "../../assets/Js/tokenHandler";
import { getDateFormat1 } from "../../assets/Js/getDateFormat1";
import { dateFormatEnum } from "../../assets/Js/dateFormatEnum";

const mapStateToProps = (state) => {
  return {
    selectedAthlete: state.selectedAthlete,
    gymData: state.gymData,
  };
};

export default connect(
  mapStateToProps,
  null
)(
  class Billing extends Component {
    constructor(props) {
      super(props);
      this.state = {
        showError: false,
        isLoading: false,
        billing: [],
        selectedBilling: [],
      };
    }

    componentDidMount() {
      if (this.props.athelteId) {
        this.getBilling();
      }
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevProps.athelteId !== this.props.athelteId) {
        this.getBilling();
      }
    }

    getBilling = async () => {
      let url = `${projectSettings.baseUrl}/subscriptions/stats/${this.props.athelteId}`;
      let header = false;
      let data = null;
      let type = "GET";
      let token = getPlainToken();

      let response = "";

      if (response === "") {
        this.setState({ isLoading: true });
      }

      response = await callAPI(url, header, type, data, token);

      if (response) {
        this.setState({ isLoading: false });
        if (response.type === "error") {
          this.setState({ showError: true });
        } else if (response.type === "success") {
          this.setState({ selectedBilling: response.data });
          this.setState({ billing: response.data });
        }
      }
    };

    searchHandler = (filterdBillingInfo) => {
      this.setState({ selectedBilling: filterdBillingInfo });
    };

    render() {
      return (
        <>
          <div className="bg-white dashboardsubSection shadow-sm">
            <div>
              {this.state.isLoading ? (
                <div className="w-100 p-5">
                  <Spinner />
                </div>
              ) : (
                <>
                  <div>
                    <div
                      className={`pt-3 pl-3 pr-3 d-flex justify-content-between align-items-end`}
                    >
                      <div className="h4 mt-3 ml-2 mb-0">Billing</div>

                      <SearchBox
                        data={this.state.billing}
                        propertyToLookFor={"Track"}
                        changeHandler={this.searchHandler}
                        searchBoxStyles={`searchBox inline`}
                      />
                    </div>
                    {this.state.showError ||
                    this.state.selectedBilling.length ? (
                      <div className="colorBgWhite p-3">
                        <div class="table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th>Track</th>
                                <th>Status</th>
                                <th>Billing</th>
                                <th>Created</th>
                                <th>Expiry</th>
                              </tr>
                            </thead>
                            <tbody className="primaryScrollBar tertiaryScrollBar">
                              {this.state.selectedBilling.map(
                                (currVal, index, arr) => {
                                  return (
                                    <tr
                                      className="border-bottom"
                                      key={`tableRow${index}`}
                                    >
                                      <td id={`track${index}`}>
                                        {currVal.Track}
                                      </td>
                                      <td id={`status${index}`}>
                                        {currVal?.Status && (
                                          <Badge
                                            status={currVal.Status}
                                            text={currVal.Status}
                                          />
                                        )}
                                      </td>
                                      <td id={`billing${index}`}>
                                        <span class="badge-auto p-1">Auto</span>
                                      </td>
                                      <td id={`created${index}`}>
                                        {getDateFormat1(
                                          this.props.UTCLocal({
                                            type: dateFormatEnum.local,
                                            date: currVal.Created,
                                          }),
                                          "yyyy/mm/dd"
                                        )}
                                      </td>
                                      <td id={`ends${index}`}>
                                        {getDateFormat1(
                                          this.props.UTCLocal({
                                            type: dateFormatEnum.local,
                                            date: currVal.Ends,
                                          }),
                                          "yyyy/mm/dd"
                                        )}
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ) : (
                      <NoInfoFound
                        className="mt-5"
                        text="No billing data available"
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      );
    }
  }
);
